import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/logo.png";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  // ref for dropdown (if you want to keep it for future use)
  const dropdownRef = useRef(null);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Menu", path: "/menu" },
    { name: "Drinks", path: "/drinks" },
    { name: "Reservations", path: "/reservations" },
    { name: "Contact", path: "/contact" },
  ];

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <>
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-background-light/80 backdrop-blur-md border-b border-primary/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/">
              <div className="flex items-center gap-2">
                <img
                  src={Logo}
                  alt="Logo"
                  className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 object-contain"
                />
                <div className="flex flex-col">
                  <span className="font-extrabold tracking-tight text-secondary text-lg xs:text-xl sm:text-2xl md:text-3xl leading-none">
                    Dee Delicious
                  </span>

                  <span className="text-primary font-extrabold leading-none text-base xs:text-lg sm:text-xl md:text-2xl">
                    Afro-Caribbean Restaurant
                  </span>
                </div>
              </div>
            </Link>

            {/* Desktop Links */}
            <div className="hidden nav:flex items-center gap-8 font-medium">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.path;
                return (
                  <Link
                    key={link.name}
                    to={link.path}
                    className={`hover:text-primary transition-colors cursor-pointer ${
                      isActive ? "text-primary" : "text-stone-600"
                    }`}
                  >
                    {link.name}
                  </Link>
                );
              })}
            </div>

            {/* Order Now button (login optional, always visible) */}
            <div className="flex items-center gap-4 relative">
              <Link
                to="/menu"
                className="hidden sm:flex items-center gap-2 px-6 py-2.5 bg-primary text-white font-semibold rounded-full hover:shadow-lg hover:shadow-primary/30 transition-all active:scale-95"
              >
                Order Now
              </Link>

              {/* Mobile Menu Toggle */}
              <button
                className="nav:hidden w-12 h-12 flex items-center justify-center text-dark-green text-4xl"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <span className="material-icons">
                  {mobileMenuOpen ? "close" : "menu"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu + Overlay */}
      {mobileMenuOpen && (
        <>
          {/* Overlay */}
          <div
            className="fixed left-0 right-0 bottom-0 bg-black/60 z-[999]"
            style={{ top: "5rem" }}
            onClick={() => setMobileMenuOpen(false)}
          />

          {/* Mobile Menu */}
          <div
            className="nav:hidden fixed left-0 w-full bg-white z-[1000] py-6 px-4 flex flex-col gap-4 shadow-lg animate-in fade-in slide-in-from-top-4 duration-300"
            style={{ top: "5rem" }}
          >
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-lg font-semibold hover:text-primary ${
                  location.pathname === link.path
                    ? "text-primary"
                    : "text-stone-600"
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}

            <div className="flex flex-col gap-3 pt-4">
              <Link
                to="/menu"
                className="w-full py-3 bg-primary text-white font-bold rounded-xl text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Order Now
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
}
